import DownloadIcon from '@mui/icons-material/Download';
import { Button, ButtonProps } from '@mui/material';
import { openExternal } from 'utils/openExternal';
import { useTranslation } from 'react-i18next'

export function DownloadClientButton(props: ButtonProps) {
  const { t } = useTranslation()
  return (
    <Button
      variant="contained"
      color="primary"
      startIcon={<DownloadIcon />}
      onClick={() => openExternal('https://dj-play.it/download')}
      {...props}
    >
      {t('downloadApp', 'Download App')}
    </Button>
  );
}
